import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatAutocompleteTrigger, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { CommonService } from 'src/app-core/services/common.service';
import { CommonDataModel } from '../../common-data-model';

@Component({
    selector: 'app-account-dialog',
    templateUrl: './account-dialog.component.html',
    styleUrls: ['./account-dialog.component.scss']
})
export class AccountDialogComponent implements OnInit {

    @ViewChild('matAccountsAutocomplete', { read: MatAutocompleteTrigger, static: false }) accountsAutoComplete: MatAutocompleteTrigger;
    commonDataModel = new CommonDataModel();
    confirmButton = false;
    confirmText: any;
    isShowCloseButton = true;
    selectedAccount = this.commonDataModel.accountDataModel;
    accounts: any = [];
    copyAccounts: any = [];
    searchText: string = '';
    searchTextChanged = new Subject<any>();

    constructor(
        private commonService: CommonService,
        private dialogRef: MatDialogRef<AccountDialogComponent>,
        @Inject(MAT_DIALOG_DATA) confirmText?: any) {
        this.confirmText = confirmText;
        this.accounts = confirmText.dropDownData.map((account: {
            accountId: { toString: () => any; };
        }) => Object.assign(account, { accountId: account.accountId }));
        this.copyAccounts = this.accounts;
        this.searchTextChanged.pipe(debounceTime(500)).subscribe((data: any) => {
            this.onGetAccounts(data.searchText);
        });
    }

    ngOnInit() {
    }

    onConfirm() {
        this.confirmButton = true;
        this.dialogRef.close({ confirmResult: this.confirmButton, accountInfo: this.selectedAccount });
    }

    onClose(value: any) {
        this.confirmButton = value;
        this.dialogRef.close({ confirmResult: this.confirmButton });
    }

    onBindAddress(item: any): string | undefined {
        return item ? `${item.accountName}` : undefined;
    }

    onOpenAccountOption() {
        this.accountsAutoComplete.openPanel();
    }

    onAccountChange(selectedAccount: any) {
        this.selectedAccount = selectedAccount;
    }

    onSearchChange(searchString: string) {
        if (!searchString || searchString.length > 2) {
            this.searchTextChanged.next({ searchText: searchString });
        }
    }

    onGetAccounts(val: string) {
        this.commonService.getAccounts(val).subscribe(response => {
            this.accounts = response.data;
        });
    }

}
